<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333 2.667 48.2 2.667 32 15.8 2.667 32 2.667zm9.886 19.447c-1.042-1.041-2.73-1.041-3.772 0L32 28.23l-6.114-6.115-.134-.124c-1.047-.915-2.64-.874-3.638.124l-.124.134c-.915 1.047-.874 2.64.124 3.638L28.23 32l-6.115 6.114-.124.134c-.915 1.047-.874 2.64.124 3.638l.134.124c1.047.915 2.64.874 3.638-.124L32 35.77l6.114 6.115.134.124c1.047.915 2.64.874 3.638-.124l.124-.134c.915-1.047.874-2.64-.124-3.638L35.77 32l6.115-6.114.124-.134c.915-1.047.874-2.64-.124-3.638z" transform="translate(-1220 -271) translate(1220 271)"/>
            </g>
        </g>
    </g>
</svg>
